module.exports = __webpack_public_path__ + "static/media/screener-1.848b402e.png";